import { ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { StyledModal } from '@/styles.ts';
import { ModalControllerType } from '@/types.ts';

import { BiomassModalContent } from './biomassModal/BiomassModalContent.tsx';

interface BiomassModalProps {
  widgetId: string;
  modalController: ModalControllerType;
}

export const BiomassModal = ({ widgetId, modalController }: BiomassModalProps) => {
  const { t } = useTranslation(['orbitOne']);
  return (
    <StyledModal open={modalController.open} onClose={modalController.onClose}>
      <ModalHeader title={t('orbitOne:biomass.config.title')} onClose={modalController.onClose} />
      <BiomassModalContent
        widgetId={widgetId}
        onSave={modalController.onClose}
        onClose={modalController.onClose}
      />
    </StyledModal>
  );
};
